import { currencyQuery } from "../../api/graphql/queries/currency";
import { updateCurrencyMutation } from "../../api/graphql/queries/currency";
import { FETCH_CURRENCY, UPDATE_CURRENCY} from "../actions/actionTypes";
import graphqlClient from "../../api/axios_interceptor";
import { updateActionErrors } from "./updateErrors";

const fetchCurrencyMiddleware = async (action) => {
  try {
    const queryResult = await graphqlClient({
      data: {
        query: currencyQuery(action.payload),
      },
    });
    if (queryResult.data.errors) {
      action = updateActionErrors(action, queryResult.data.errors);
    } else {
      const result = queryResult.data.data;
      action = {
        ...action,
        payload: {
          ...action.payload,
          customerCurrency: result.customerCurrency
        }
      };
    }
  } catch (error) {
    console.error(error);
  }
  return action;
};

export const updateCurrencyMiddleware = async (action) => {
        try {
        const query = updateCurrencyMutation( action.payload.customerCurrency )
        await graphqlClient({
            data: { query }
        }).then( (queryResult) => {
          if (queryResult.data.errors) {
              action = updateActionErrors(action, queryResult.data.errors);
          } else if(queryResult.data.data.updateSettings.error){
              action = updateActionErrors(action,queryResult.data.data.updateSettings.error.message);
              action = {
                  errorCode: queryResult.data.data.updateSettings.error.code,
                  ...action
              }
          } else {
              action = ({
                  ...action,
                  payload: {
                      ...action.payload
                  }
              });
          }
      })

  }catch(error){
      console.log(error);
      action = updateActionErrors(action, error);
  }
  return action;
}

export const currencyMiddleware = (api) => (next) => async (action) => {
  switch (action.type) {
    case FETCH_CURRENCY:
      action = await fetchCurrencyMiddleware(action);
      break;
    case UPDATE_CURRENCY:
      action = await updateCurrencyMiddleware(action);
      break;
    default:
      break;
  }
  return next(action);
};

